(function () {
  var pixelId = window.FINEYST_OPENAI_PIXEL_ID || 'RiLfuFPMMCC3qaUYLaJdPF';
  var context = window.FineystShopifyAnalytics || {};
  var storage = window.sessionStorage;

  function toNumber(value) {
    var number = parseFloat(String(value || '0').replace(/[^0-9.-]/g, ''));
    return isNaN(number) ? 0 : number;
  }

  // OpenAI expects `amount` as an integer in the minor currency unit (cents).
  function toMinorUnits(value) {
    return Math.round(toNumber(value) * 100);
  }

  function currencyOf(source) {
    return (source && source.currency) || context.currency || 'USD';
  }

  // NOTE: `order_created` is NOT sent from the theme. It is owned by the
  // Shopify Custom Pixel (see scripts/openai-custom-pixel-order-created.js),
  // which fires on checkout_completed. Do not re-add it here — the two would
  // double-count every order.

  function measure(eventName, data, options) {
    if (!pixelId || typeof window.oaiq !== 'function') return null;
    if (options) {
      window.oaiq('measure', eventName, data || {}, options);
    } else {
      window.oaiq('measure', eventName, data || {});
    }
    return eventName;
  }

  function mapContents(items, currency) {
    return (items || []).map(function (item) {
      return {
        id: String(item.id || ''),
        name: item.name || '',
        content_type: 'product',
        quantity: parseInt(item.quantity, 10) || 1,
        amount: toMinorUnits(item.price),
        currency: currency
      };
    });
  }

  // Shopify's cart.total_price ignores the configurator's `custom_price` line
  // property, so it under-reports the price the customer actually sees. Sum the
  // mapped line items instead to keep `amount` consistent with `contents`.
  function contentsTotal(contents, fallback) {
    if (!contents || !contents.length) return toMinorUnits(fallback);
    return contents.reduce(function (sum, item) {
      return sum + (item.amount || 0) * (item.quantity || 1);
    }, 0);
  }

  // Fires again only when the cart contents actually change, so a refresh or a
  // back-navigation to /cart does not inflate the event count.
  function cartFingerprint(cart) {
    return (cart.items || []).map(function (item) {
      return String(item.id || '') + 'x' + (parseInt(item.quantity, 10) || 1) + '@' + toNumber(item.price);
    }).join('|');
  }

  function trackPageViewed() {
    measure('page_viewed', { type: 'contents' });
  }

  function trackItemsAdded() {
    var cart = context.cart;
    if (!cart || !cart.items || !cart.items.length) return;

    var storageKey = 'oaiq-items-added-' + cartFingerprint(cart);
    if (storage && storage.getItem(storageKey)) return;

    var currency = currencyOf(cart);
    var contents = mapContents(cart.items, currency);
    measure('items_added', {
      type: 'contents',
      amount: contentsTotal(contents, cart.value),
      currency: currency,
      contents: contents
    });

    if (storage) storage.setItem(storageKey, 'true');
  }

  function trackCheckoutStarted() {
    var cart = context.cart;
    if (!cart || !cart.items || !cart.items.length) return;

    // Guards against a double-click firing the event twice.
    var now = Date.now();
    var last = storage && storage.getItem('oaiq-checkout-started-at');
    if (last && now - parseInt(last, 10) < 5000) return;

    var currency = currencyOf(cart);
    var contents = mapContents(cart.items, currency);
    measure('checkout_started', {
      type: 'contents',
      amount: contentsTotal(contents, cart.value),
      currency: currency,
      contents: contents
    });

    if (storage) storage.setItem('oaiq-checkout-started-at', String(now));
  }

  // `lead_created` is handled server-side only — see the Conversions API
  // call in the backend's /api/shopify/draft-orders/from-form endpoint.
  // Firing it here as well would double-count every submission.

  function bindCheckoutClicks() {
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      if (target.closest('[name="checkout"], .cart-checkout-btn')) {
        trackCheckoutStarted();
      }
    });
  }

  window.FineystOpenAI = {
    pixelId: pixelId,
    measure: measure,
    trackPageViewed: trackPageViewed,
    trackItemsAdded: trackItemsAdded,
    trackCheckoutStarted: trackCheckoutStarted
  };

  trackPageViewed();
  trackItemsAdded();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCheckoutClicks);
  } else {
    bindCheckoutClicks();
  }
})();
